var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 72,
    viewBox: "0 0 73 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_706_18590)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.1563 2.11035V61.4541C49.1563 62.6352 48.2285 63.5635 47.0469 63.5635H30.1719C28.9903 63.5635 28.0625 62.6352 28.0625 61.4541L2.75 2.11035C2.75 0.928772 3.6778 0.000976562 4.85938 0.000976562H47.0469C48.2285 0.000976562 49.1563 0.928772 49.1563 2.11035Z",
    fill: "url(#paint0_linear_706_18590)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1563 2.11035V61.4541C49.1563 62.6352 48.2285 63.5635 47.0469 63.5635H30.1719C28.9903 63.5635 28.0625 62.6352 28.0625 61.4541L21.7344 46.6885V0.000976562H47.0469C48.2285 0.000976562 49.1563 0.928772 49.1563 2.11035Z",
    fill: "url(#paint1_linear_706_18590)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0997 12.8683L5.78717 0.21207C5.15491 -0.0834619 4.35291 -0.0834619 3.76239 0.296665C3.12958 0.717991 2.75 1.3931 2.75 2.11051V61.4543C2.75 62.3821 3.34052 63.1841 4.18427 63.4368L21.7344 69.3013L29.4968 71.8743C30.118 72.1231 30.914 71.9825 31.3952 71.6216C31.944 71.1997 32.2813 70.5669 32.2813 69.8918V14.7668C32.2813 13.9653 31.8171 13.2479 31.0997 12.8683Z",
    fill: "url(#paint2_linear_706_18590)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2813 14.7669V69.8919C32.2813 70.567 31.9434 71.1998 31.3952 71.6217C30.9184 71.9793 30.1241 72.126 29.4968 71.8744L21.7344 69.3014V8.18555L31.0997 12.8685C31.8171 13.248 32.2813 13.9655 32.2813 14.7669Z",
    fill: "url(#paint3_linear_706_18590)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4896 46.4393C53.8035 46.0729 53.375 45.3582 53.375 44.5793V42.4699H38.6094C37.4432 42.4699 36.5 41.5262 36.5 40.3605V31.923C36.5 30.7568 37.4432 29.8136 38.6094 29.8136H53.375V27.7043C53.375 26.9253 53.8035 26.2107 54.4896 25.8437C55.1735 25.4795 56.0079 25.5207 56.6544 25.9492L69.3107 34.3867C69.8979 34.7778 70.25 35.437 70.25 36.1418C70.25 36.846 69.8979 37.5052 69.3107 37.8963L56.6544 46.3338C56.0002 46.7705 55.1658 46.8024 54.4896 46.4393Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8438 31.9229V40.3604C23.8438 41.5414 22.916 42.4697 21.7344 42.4697C20.5528 42.4697 19.625 41.5414 19.625 40.3604V31.9229C19.625 30.7413 20.5528 29.8135 21.7344 29.8135C22.916 29.8135 23.8438 30.7413 23.8438 31.9229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8438 31.9229V40.3604C23.8438 41.5414 22.916 42.4697 21.7344 42.4697V29.8135C22.916 29.8135 23.8438 30.7413 23.8438 31.9229Z",
    fill: "#EFE2DD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_706_18590",
    x1: -20.4531,
    y1: -24.1528,
    x2: 56.61,
    y2: -23.0462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57EBDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8FA3C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_706_18590",
    x1: 8.02344,
    y1: -24.1528,
    x2: 53.5668,
    y2: -23.7664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57EBDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8FA3C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_706_18590",
    x1: 18.9922,
    y1: -11.3333,
    x2: 28.8466,
    y2: 115.577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD749B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#281AC8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_706_18590",
    x1: 27.5352,
    y1: -1.85937,
    x2: 48.5605,
    y2: 107.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD749B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#281AC8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_706_18590"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/Logout.a5493b3aa5459886e951b91a2bfe4056.svg";
export { ForwardRef as ReactComponent };